/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useParams } from "react-router-dom";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import { useCustomer } from "~/context/User/Customer";
import { RouteParams } from "~/models";
import { JiraProject } from "~/models/jiraProject";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";

type JiraProjectDeleteProps = {
  initialValues: JiraProject;
  deleteCallback?: () => void;
};

function JiraProjectDelete({
  initialValues,
  deleteCallback,
}: JiraProjectDeleteProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const state = useParams<RouteParams>();
  const { customerId } = state;

  const { customer } = useCustomer();

  const name = initialValues?.code;

  const { showError } = useShowError();
  const { Axios } = useAxios();

  return (
    <>
      <Button
        icon="trash"
        size="sm"
        onClick={() => setIsOpen(true)}
        severity="low"
      >
        Delete
      </Button>
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            const updateData = {
              ...customer,
            };
            const arr = updateData.toolsAndIntegrations?.jiraProjects;

            if (updateData.toolsAndIntegrations) {
              updateData.toolsAndIntegrations.jiraProjects =
                arr?.filter((p) => p.code !== initialValues?.code) ?? null;
            }
            await Axios().put(`/customers/${customerId}`, updateData);

            setIsOpen(true);
            deleteCallback && deleteCallback();
            showSuccess(
              generateActionSuccessText(`The ${name}`)()("deleted")()
            );
          } catch (e) {
            showError(e.response);
          } finally {
            setIsOpen(false);
          }
        }}
        actionLabel="Delete"
        contentLabel="Delete JiraProject"
      >
        {generateActionConfirmText(`${name}`)("delete")()} <br />
      </ModalConfirm>
    </>
  );
}

export { JiraProjectDelete };
